import { useEffect, useRef } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HEARTBEAT_INTERVAL_MS = 15_000;

const getOrCreateViewerId = () => {
  if (typeof window === "undefined") return null;
  const KEY = "rss_viewer_id";
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id =
      (crypto?.randomUUID && crypto.randomUUID()) ||
      `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(KEY, id);
  }
  return id;
};

export const useViewerHeartbeat = () => {
  const timerRef = useRef(null);

  useEffect(() => {
    const viewer_id = getOrCreateViewerId();
    if (!viewer_id) return;

    const send = () => {
      // Don't beep when tab is hidden — saves bandwidth and keeps the count honest
      if (document.visibilityState !== "visible") return;
      fetch(`${API}/viewers/heartbeat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ viewer_id }),
        keepalive: true,
      }).catch(() => {
        /* ignore — best-effort */
      });
    };

    send(); // immediate
    timerRef.current = window.setInterval(send, HEARTBEAT_INTERVAL_MS);

    const onVisible = () => {
      if (document.visibilityState === "visible") send();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
};
